/* ============================================================================
   assets/r24-paypal-later.js — ausgelagert aus snippets/r24-paypal-later.liquid (P2-1, 25.09.2026).
   Ab jetzt ist DIESE Datei die Quelle der Wahrheit; im Liquid steht an der alten
   Stelle nur noch der Skript-Tag (Verweis R24-JS-AUSGELAGERT). Pruefung:
   npm run css:check (audit/perf/extract-css.mjs, Abschnitt "scripts").
   ============================================================================ */
  (function () {
    /* Liquid-Werte (Botschafts-Seite, client-id) am eigenen Skript-Tag. */
    var CUR = document.currentScript;
    var I = {
      clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
      cal: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4.5" width="18" height="16" rx="2"/><path d="M3 9h18M8 3v3M16 3v3M7.5 13h3M7.5 16.5h6"/></svg>',
      store: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9V5h16v4M4 9l1 11h14l1-11M4 9h16M9 20v-5h6v5"/></svg>',
      raten: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="6" width="19" height="13" rx="2"/><path d="M2.5 10h19"/><path d="M7 15h4"/></svg>'
    };

    function eur(s) {
      if (!s) return 0;
      var m = String(s).replace(/[^\d.,]/g, '').replace(/\./g, '').replace(',', '.');
      var n = parseFloat(m);
      return isFinite(n) && n > 0 ? n : 0;
    }
    function ppMsg(amount) {
      var d = document.createElement('div');
      d.className = 'r24pp-msg';
      d.setAttribute('data-pp-message', '');
      d.setAttribute('data-pp-placement', 'product');
      d.setAttribute('data-pp-layout', 'text');
      d.setAttribute('data-pp-amount', String(amount));
      return d;
    }
    /* Botschaft nur dort, wo sie hingehoert: Vorlage product/cart (Liquid) UND
       ein eingehaengter `.r24pp-msg`-Behaelter. Sonst kein SDK. */
    var MSG_PAGE = !!(CUR && CUR.getAttribute('data-msg-page') === 'true');
    function wantSdk(block) {
      if (MSG_PAGE && window.R24PPLoad && block && block.querySelector('.r24pp-msg')) window.R24PPLoad();
    }
    /* render() ohne Treffer meldet PayPal als `paypal_messages_invalid_selector`
       — also nur nachzeichnen, wenn es einen Behaelter gibt. */
    function rerender() {
      if (!document.querySelector('.r24pp-msg')) return;
      if (!(window.r24ppSDK && window.r24ppSDK.Messages)) return;
      try { window.r24ppSDK.Messages().render('.r24pp-msg'); }
      catch (e) { if (window.console) console.warn('[r24pp] PayPal-Botschaft nicht gezeichnet:', e); }
    }
    /* Offizielles PayPal-Modal je Zahlungsart (Betrag + repräsentatives Beispiel rendert PayPal). */
    var CID = (CUR && CUR.getAttribute('data-cid')) || '';
    var _modal = null;
    function getModal() {
      if (!_modal && window.r24ppSDK && window.r24ppSDK.MessagesModal) {
        try { _modal = window.r24ppSDK.MessagesModal({ account: 'client-id:' + CID, currency: 'EUR', buyerCountry: 'DE' }); } catch (e) {}
      }
      return _modal;
    }
    function showModal(offer, amount, fallbackUrl) {
      var m = getModal();
      if (!m) { if (fallbackUrl) window.open(fallbackUrl, '_blank', 'noopener'); return; }
      var opt = { currency: 'EUR' }; if (amount) opt.amount = amount; if (offer) opt.offer = offer;
      try { m.show(opt); }
      catch (e) { try { m.show({ currency: 'EUR', amount: amount }); } catch (e2) { if (fallbackUrl) window.open(fallbackUrl, '_blank', 'noopener'); } }
    }
    /* Ausserhalb von Produkt/Warenkorb gibt es das SDK erst auf Klick: es wird
       hier angefordert und der Plan zeigt sich als Modal — der Rueckfall (neuer
       Tab mit der PayPal-Seite) bleibt fuer den Netzfehler. 
 Erster Tipp ausserhalb von Produkt/Warenkorb laedt das SDK (74 KB). Waehrenddessen nur
       EIN offenes Oeffnen — Mehrfachtipps stapelten sonst mehrere show()-Aufrufe (Review R2).
       Frei wird es, sobald das Laden endet: Erfolg → Modal, Netzfehler (onerror → null) →
       showModal nimmt den Rueckfall. */
    var ppWaiting = false;
    function openModal(offer, amount, fallbackUrl) {
      if (getModal()) { showModal(offer, amount, fallbackUrl); return; }
      if (!window.R24PPLoad) { if (fallbackUrl) window.open(fallbackUrl, '_blank', 'noopener'); return; }
      if (ppWaiting) return;
      ppWaiting = true;
      window.R24PPLoad().then(function () { ppWaiting = false; showModal(offer, amount, fallbackUrl); });
    }
    /* Klick auf eine Karte → passendes PayPal-Modal (Fallback: PayPal-Seite). */
    document.addEventListener('click', function (e) {
      var card = e.target.closest ? e.target.closest('a.r24pp__c') : null;
      if (!card) return;
      e.preventDefault();
      var block = card.closest('.r24pp');
      /* Auf der Produktseite stehen Botschaft (unter dem Preis) und Dienste-Liste („Zahlung &
         Service“) getrennt — der Betrag kommt dann aus der Botschaft der Seite. */
      var pdp = card.closest('[data-r24pd]');
      var msg = (block && block.querySelector('.r24pp-msg')) || (pdp && pdp.querySelector('.r24pp-msg'));
      var amt = msg ? parseFloat(msg.getAttribute('data-pp-amount')) : 0;
      openModal(card.getAttribute('data-offer'), (amt > 0 ? amt : undefined), card.getAttribute('href'));
    });
    /* Ruhige 3-Dienste-Karte (alle drei korrekt gekennzeichnet). */
    function servicesBlock(amount) {
      var U = 'https://www.paypal.com/de/digital-wallet/ways-to-pay/buy-now-pay-later';
      function cardAttr(offer) { return ' class="r24pp__c" href="' + U + '" target="_blank" rel="noopener" data-offer="' + offer + '"'; }
      var b = document.createElement('div');
      b.className = 'r24pp';
      b.innerHTML =
        '<div class="r24pp__hd"><span class="r24pp__pp"><i>Pay</i><em>Pal</em></span><b>Später bezahlen — flexibel &amp; sicher</b></div>'
        + '<div class="r24pp__grid">'
        + '<a' + cardAttr('PAY_LATER_PAY_IN_1') + '><span class="r24pp__ic">' + I.clock + '</span><strong>Bezahlung nach 30 Tagen</strong><p>Erst erhalten, dann bequem innerhalb von 30 Tagen zahlen.</p></a>'
        + '<a' + cardAttr('PAY_LATER_LONG_TERM') + '><span class="r24pp__ic">' + I.cal + '</span><strong>PayPal Ratenzahlung</strong><p>Den Kaufbetrag in 3, 6, 12 oder 24 Monatsraten aufteilen.</p></a>'
        + '<a' + cardAttr('PAY_LATER_LONG_TERM') + '><span class="r24pp__tag">im Laden</span><span class="r24pp__ic">' + I.store + '</span><strong>Ratenzahlung To&nbsp;Go</strong><p>Ratenkauf beim Bezahlen im Geschäft — über die PayPal-App.</p></a>'
        + '</div>';
      /* Fuß = OFFIZIELLE PayPal-Botschaft (rendert „Bezahlen Sie in bis zu 24
         monatlichen Raten. Mehr erfahren" samt Modal mit repräsentativem Beispiel
         + Anbieter/Bonitäts-Angaben). Die frühere statische „Anbieter:"-Zeile ist
         entfernt (Owner-Wunsch); die rechtlich nötigen Angaben liefert PayPals
         eigenes Message-Widget/Modal. Ohne Freischaltung bleibt der Fuß leer (:empty). */
      if (amount) {
        var ft = document.createElement('div');
        ft.className = 'r24pp__ft';
        ft.appendChild(ppMsg(amount));
        b.appendChild(ft);
      }
      return b;
    }

    /* Produktseite (R24 Luxe, Runde 3): die drei Dienste als ruhige Liste — ohne Kopf,
       ohne Kachel-Raster, ohne Botschaft (die steht offen unter dem Preis). */
    function servicesList() {
      var U = 'https://www.paypal.com/de/digital-wallet/ways-to-pay/buy-now-pay-later';
      function row(offer, ic, title, text, tag) {
        return '<a class="r24pp__c" href="' + U + '" target="_blank" rel="noopener" data-offer="' + offer + '">'
          + '<span class="r24pp__ic">' + ic + '</span><span class="r24pp__tx"><strong>' + title + '</strong>'
          + (tag ? '<span class="r24pp__tag">' + tag + '</span>' : '') + '<p>' + text + '</p></span></a>';
      }
      var b = document.createElement('div');
      b.className = 'r24pp r24pp--list';
      b.innerHTML =
          row('PAY_LATER_PAY_IN_1', I.clock, 'Bezahlung nach 30 Tagen', 'Erst erhalten, dann bequem innerhalb von 30 Tagen zahlen.')
        + row('PAY_LATER_LONG_TERM', I.cal, 'PayPal Ratenzahlung', 'Den Kaufbetrag in 3, 6, 12 oder 24 Monatsraten aufteilen.')
        + row('PAY_LATER_LONG_TERM', I.store, 'Ratenzahlung To&nbsp;Go', 'Ratenkauf beim Bezahlen im Geschäft — über die PayPal-App.', 'im Laden');
      return b;
    }

    /* ── Produktseite (R24 Luxe, Runde 3) ──
       Die OFFIZIELLE PayPal-Botschaft gehört zum Preis: sie kommt in den Behälter
       [data-r24pp-slot] direkt unter „inkl. MwSt., zzgl. Versand“. Die drei Dienste stehen
       als Liste im aufklappbaren Bereich „Zahlung & Service“ ([data-r24pp-services]).
       Vorher: eine blau getönte Kachel-Karte (Kopf, drei Kacheln, Fuß) unter den Aktionen.
       Ohne Behälter (fremde Produktvorlage) wird nichts eingehängt — und kein SDK geladen.
       Gibt es keinen Preis (Kombination nicht verfügbar → „—“), blendet sich die Botschaft
       aus, statt den Betrag der vorigen Variante zu nennen. */
    function mountPDP() {
      var now = document.querySelector('[data-r24pd] [data-now]');
      var slot = document.querySelector('[data-r24pd] [data-r24pp-slot]');
      if (!now || !slot || document.querySelector('[data-r24pd] .r24pp')) return;
      var amt = eur(now.textContent);
      if (!amt) return;
      var block = document.createElement('div');
      block.className = 'r24pp r24pp--pdp';
      block.appendChild(ppMsg(amt));
      slot.appendChild(block);
      var list = document.querySelector('[data-r24pd] [data-r24pp-services]');
      if (list) list.appendChild(servicesList());
      wantSdk(block);
      var msg = block.querySelector('.r24pp-msg');
      try {
        new MutationObserver(function () {
          var a = eur(now.textContent);
          block.hidden = !a;
          if (a && msg && msg.getAttribute('data-pp-amount') !== String(a)) {
            msg.setAttribute('data-pp-amount', String(a)); rerender();
          }
        }).observe(now, { childList: true, characterData: true, subtree: true });
      } catch (e) { if (window.console) console.warn('[r24pp] Preisbeobachter nicht verfuegbar:', e); }
    }

    /* ── Warenkorb (Seite): Dienste-Karte unter der Summe ── */
    function mountCart() {
      /* R24-Warenkorbseite (/cart): eigener Block DIREKT unter der Zusammenfassung
         (unter „Zur Kasse" + Express-Buttons); Betrag = Gesamtsumme, live nachgeführt. */
      var sum = document.querySelector('.r24cart__sum');
      if (sum && !sum.parentElement.querySelector('.r24pp')) {
        var tot = document.querySelector('[data-r24-total]') || sum.querySelector('.r24cart__total .v');
        var block = servicesBlock(tot ? eur(tot.textContent) : 0);
        block.classList.add('r24pp--cart');
        /* Handoff-Priorität: „Später bezahlen" ist niedrige Priorität → NICHT direkt
           unter die Summe, sondern in die Abschluss-Spalte kurz VOR die Trust-Liste
           (Reihenfolge: Summe · Ersparnis · Versand · Später bezahlen · Trust · Chips). */
        var trust = document.querySelector('.r24cart__right .r24cart__trust') || document.querySelector('.r24cart__trust');
        if (trust && trust.parentElement) { trust.parentElement.insertBefore(block, trust); }
        else { sum.insertAdjacentElement('afterend', block); }
        wantSdk(block);
        if (tot) {
          try {
            new MutationObserver(function () {
              var a = eur(tot.textContent), m = block.querySelector('.r24pp-msg');
              if (a && m && m.getAttribute('data-pp-amount') !== String(a)) { m.setAttribute('data-pp-amount', String(a)); rerender(); }
            }).observe(tot, { childList: true, characterData: true, subtree: true });
          } catch (e) {}
        }
      }
    }

    /* ── Produktkarten: dezenter „In Raten zahlbar"-Chip (keine Zahlen) ── */
    function mountCards() {
      var boxes = new Set();
      document.querySelectorAll('[class*="card__price"],[class*="col-card__price"]').forEach(function (b) { boxes.add(b); });
      document.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        var p = a.querySelector('[class*="price"]'); if (p) boxes.add(p);
      });
      boxes.forEach(function (box) {
        if (box.__ppchip || box.closest('[data-r24pd]')) return;
        box.__ppchip = 1;
        var amt = eur(box.textContent);
        var link = box.closest('a[href*="/products/"]');
        var purl = link ? link.getAttribute('href') : '';
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'r24pp-chip';
        chip.setAttribute('aria-label', 'PayPal Ratenzahlung – Zahlungsplan für dieses Produkt ansehen');
        chip.innerHTML = I.raten + '<span>In Raten zahlbar</span><span class="r24pp-chip__go" aria-hidden="true">· Plan ansehen ›</span>';
        chip.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          openModal('PAY_LATER_LONG_TERM', (amt > 0 ? amt : undefined), purl);
        });
        box.insertAdjacentElement('afterend', chip);
      });
    }

    function runAll() { mountPDP(); mountCart(); mountCards(); }
    /* defer laeuft bei readyState 'interactive', aber VOR DOMContentLoaded — wie vorher inline
       erst auf DOMContentLoaded zeichnen (nach den Sektions-Skripten), nicht sofort. */
    if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', runAll);
    else runAll();
    setTimeout(runAll, 1200);
    setTimeout(runAll, 3000);
    document.addEventListener('t4s:cart:updated', mountCart);
    document.addEventListener('cart:updated', mountCart);
    /* Bewusst ein Ereignis und NICHT `R24PPLoad().then(...)`: der Aufruf wuerde
       das SDK auf JEDER Seite anfordern — auch dort, wo es keine Botschaft gibt. */
    document.addEventListener('r24pp:ready', function () { runAll(); rerender(); });
  })();
